import { useState } from 'react';
import { Mic, MicOff, Loader } from 'lucide-react';
import { participantService } from '../../../services/participant.service';

interface Props {
  sessionId: string;
  available: boolean;
  busy: boolean;
}

export function ConverseCTA({ sessionId, available, busy }: Props) {
  const [confirming, setConfirming] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!available) return null;

  async function handleConverse() {
    if (busy || loading) return;
    if (!confirming) {
      setConfirming(true);
      setTimeout(() => setConfirming(false), 4000);
      return;
    }
    setConfirming(false);
    setLoading(true);
    setError(null);
    try {
      await participantService.converse(sessionId);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="fixed bottom-20 right-4 flex flex-col items-end gap-2 z-40">
      {error && (
        <p className="text-xs text-red-400 bg-navy border border-red-400/30 rounded-lg px-3 py-1.5 max-w-48 text-right">
          {error}
        </p>
      )}
      {confirming && (
        <p className="text-xs text-white/70 bg-navy border border-white/20 rounded-lg px-3 py-1.5">
          Tap again to activate room voice
        </p>
      )}
      <button
        onClick={handleConverse}
        disabled={busy || loading}
        className={`flex items-center gap-2 px-4 py-2.5 rounded-full font-semibold text-sm shadow-lg transition-all active:scale-95 ${
          busy
            ? 'bg-white/20 text-white/40 cursor-not-allowed'
            : confirming
            ? 'bg-yellow-400 text-navy'
            : 'bg-primary text-navy'
        }`}
      >
        {loading ? (
          <Loader size={16} className="animate-spin" />
        ) : busy ? (
          <MicOff size={16} />
        ) : (
          <Mic size={16} />
        )}
        {busy ? 'In use' : confirming ? 'Confirm?' : 'Speak to room'}
      </button>
    </div>
  );
}
